import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import EventResultsPage from './EventResultsPage';
import './EventResultsModal.css';

// Результаты с плашки события — та же страница результатов, только в модальном окне.
// Раньше здесь лежала своя копия страницы, и она отставала: не было ни динамики позиций,
// ни реплея, ни сравнения. Теперь любая доработка страницы приезжает сюда сама
const EventResultsModal = ({ onClose, selectedEventId = null }) => {
  const { t } = useLanguage();

  // Пока модалка открыта, листаться должна она, а не экран под ней. Прокруткой
  // страницы заведует .app-content (не body), поэтому останавливаем именно его
  useEffect(() => {
    const appContent = document.querySelector('.app-content');
    if (!appContent) return undefined;

    const previousOverflow = appContent.style.overflowY;
    appContent.style.overflowY = 'hidden';

    return () => { appContent.style.overflowY = previousOverflow; };
  }, []);

  return (
    <div className="results-modal-overlay" onClick={onClose}>
      <div className="modal-content event-results-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header results-header">
          <div>
            <h2>{t('results.title')}</h2>
            <button className="modal-close" onClick={onClose}>&times;</button>
          </div>
        </div>

        <EventResultsPage selectedEventId={selectedEventId} embedded />
      </div>
    </div>
  );
};

export default EventResultsModal;
